import { createContext, useContext, useEffect, useState } from 'react';
import { appliquerSession } from './permissions';
import { disconnectLocalPush } from './pwaPush';
import { hydrater } from './store';

// Authentification SERVEUR : session vérifiée côté backend (cookie HttpOnly),
// aucun mot de passe et aucun rôle ne sont conservés dans le navigateur.
const API = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;

const AuthContext = createContext(null);

const sessionDe = (compte) => ({
  email: compte.email,
  name: compte.nom ?? compte.name ?? compte.email,
  role: compte.role,
  modules: compte.modules === '*' ? null : compte.modules,
  admin: compte.admin,
  // Permissions à grain fin déléguées par l'Administrateur (contrôlées aussi côté serveur).
  peut_deroger_minimum: compte.peut_deroger_minimum === true,
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [bootstrap, setBootstrap] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API}/moi`);
        if (r.ok) {
          const session = sessionDe(await r.json());
          appliquerSession(session);
          setUser(session);
        } else {
          const e = await fetch(`${API}/etat`);
          if (e.ok) setBootstrap(Boolean((await e.json()).bootstrap_requis));
        }
      } catch {
        /* serveur injoignable : l'écran de connexion reste affiché */
      }
      setLoading(false);
    })();
  }, []);

  const etablir = async (chemin, email, password) => {
    let data = null;
    try {
      const r = await fetch(`${API}/${chemin}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase(), mot_de_passe: password }),
      });
      data = await r.json().catch(() => null);
      if (!r.ok) return { error: String(data?.detail ?? `Erreur ${r.status}`) };
    } catch {
      return { error: 'Serveur injoignable : vérifiez la connexion.' };
    }
    const session = sessionDe(data);
    appliquerSession(session);
    setUser(session);
    setBootstrap(false);
    // L'hydratation du cache ne doit jamais retenir l'utilisateur sur l'écran de
    // connexion : elle se poursuit en arrière-plan et chaque écran relit ses données.
    hydrater().catch(() => {});
    return { error: null, role: session.role };
  };

  const signIn = (email, password) => etablir('connexion', email, password);
  const activer = (email, password) => etablir('activation', email, password);

  const signOut = async () => {
    await disconnectLocalPush().catch(() => {});
    await fetch(`${API}/deconnexion`, { method: 'POST' }).catch(() => {});
    appliquerSession(null);
    setUser(null);
    window.location.replace('/login');
  };

  return (
    <AuthContext.Provider value={{ user, loading, bootstrap, signIn, activer, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
